import L, { LatLngBounds, LatLngTuple } from 'leaflet';
import { MapLayer, MapLayerProps, withLeaflet } from 'react-leaflet';
import { ImageOverlayEx } from './ImageOverlayEx';

interface Props extends MapLayerProps {
  attribution?: string;
  className?: string;
  bounds: LatLngTuple[];
  opacity?: number;
  url: string;
  zIndex: number;
  onload: (event: L.LayerEvent) => void;
}

class CustomImageOverlayPure extends MapLayer<Props, ImageOverlayEx> {
  createLeafletElement(props: Props): ImageOverlayEx {
    const element = new ImageOverlayEx(props.url, props.bounds, this.getOptions(props));
    this.contextValue = { ...props.leaflet, popupContainer: element };
    return element;
  }

  updateLeafletElement(fromProps: Props, toProps: Props): void {
    if (toProps.url !== fromProps.url) {
      this.leafletElement.setUrl(toProps.url);
    }
    if (toProps.bounds && toProps.bounds !== fromProps.bounds) {
      this.leafletElement.setBounds(new LatLngBounds(toProps.bounds));
    }
    if (toProps.opacity !== fromProps.opacity) {
      this.leafletElement.setOpacity(toProps.opacity ?? 1);
    }
    if (toProps.zIndex !== fromProps.zIndex) {
      this.leafletElement.setZIndex(toProps.zIndex);
    }
    if (toProps.className !== fromProps.className) {
      this.leafletElement.setClassName(toProps.className);
    }
  }
}

export const CustomImageOverlay = withLeaflet(CustomImageOverlayPure);
